<ng-container
  *ngIf="value != undefined"
  [ngSwitch]="type"
>
  <!-- String | Number Content -->
  <ng-container *ngSwitchDefault>
    <div
      [class]="
        config?.orientation == 'vertical'
          ? 'label-value-pair-vertical-orientation'
          : 'label-value-pair-horizontal-orientation'
      "
      [ngStyle]="config?.customStyles?.value"
      [innerHTML]="value | kwikuiSafeHtml"
    ></div>
  </ng-container>

  <!-- Object Content -->
  <ng-container *ngSwitchCase="'object'">
    <div
      [class]="
        config?.orientation == 'vertical'
          ? 'label-value-pair-vertical-orientation'
          : 'label-value-pair-horizontal-orientation'
      "
      [ngStyle]="config?.customStyles?.value"
      >{{ value | json }}</div
    >
  </ng-container>

  <!-- Boolean Content -->
  <ng-container *ngSwitchCase="'boolean'">
    <!-- Show Boolean Value 'True' in Green Tick Symbol -->
    <div
      *ngIf="value"
      [class]="
        config?.orientation == 'vertical'
          ? 'label-value-pair-vertical-orientation'
          : 'label-value-pair-horizontal-orientation'
      "
      [ngStyle]="config?.customStyles?.value"
      style="display: flex; gap: 0.5rem; align-items: center; height: 100%"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #34b41f;
          border-radius: 100%;
          height: 1rem;
          width: 1rem;
          padding: 0.15rem;
        "
      >
        <div
          style="
            height: 0.6rem;
            width: 0.25rem;
            border-bottom: 0.15rem solid white;
            border-right: 0.15rem solid white;
            transform: translateY(-1px) rotate(45deg);
          "
        ></div>
      </div>
    </div>

    <!-- Show Boolean Value 'False' in Red Cross Symbol -->
    <div
      *ngIf="!value"
      [class]="
        config?.orientation == 'vertical'
          ? 'label-value-pair-vertical-orientation'
          : 'label-value-pair-horizontal-orientation'
      "
      [ngStyle]="config?.customStyles?.value"
      style="display: flex; gap: 0.5rem; align-items: center; height: 100%"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #f45725;
          color: white;
          border-radius: 100%;
          height: 1rem;
          width: 1rem;
          font-size: 0.6rem;
          padding: 0.15rem;
        "
      >
        <b>&#x2715; </b>
      </div>
    </div>
  </ng-container>

  <!-- Image Content -->
  <ng-container *ngSwitchCase="'image'">
    <img
      [class]="
        config?.orientation == 'vertical'
          ? 'label-value-pair-vertical-orientation'
          : 'label-value-pair-horizontal-orientation'
      "
      id="image"
      alt="Image"
      [src]="value"
      [ngStyle]="config?.customStyles?.value"
    />
  </ng-container>

  <!-- PDF Content -->
  <ng-container *ngSwitchCase="'pdf'">
    <a
      id="pdf"
      [class]="
        config?.orientation == 'vertical'
          ? 'label-value-pair-vertical-orientation'
          : 'label-value-pair-horizontal-orientation'
      "
      [href]="value"
      [ngStyle]="config?.customStyles?.value"
      target="_blank"
    >
      View PDF
    </a>
  </ng-container>
</ng-container>
